import { TmsRouteTypeEnum, TmsTaskTypeEnum } from '../../../../../../../enums/TmsEnum';

/**
 * 转义 HTML 特殊字符，供 BOL 拼接 innerHTML 时对来自数据库的字段做输出端转义，
 * 防止 stored XSS（如仓库 code、bagNumber 落库时携带 <img onerror=...>）。
 */
export const escapeHtml = (text?: string | null) => {
    const div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
};

/**
 * 获取缩写 sortingCode（取 "-" 分隔的最后一段，如 US-CA-LAX -> LAX）
 */
export const getAbbrSortCode = (code?: string | null) => {
    if (!code) return '';
    const segments = code.split('-');
    return segments.length ? segments[segments.length - 1] : '';
};

/**
 * 是否按「交接样式」出 BOL（两列 SHIP FROM + HANDOVER CARRIER，编辑器只开始发站）：
 * 交接路线任务，但三方任务除外 —— 三方任务按 shipmentPlan 分多段，走普通样式的多列版式
 */
export const isHandoverStyleBol = (bolData: { routeType?: number; taskType?: number }): boolean =>
    bolData.routeType === TmsRouteTypeEnum.Handover && bolData.taskType !== TmsTaskTypeEnum.ThirdParty;

/**
 * 交接+三方任务：除始发站外，各站点联系人姓名/电话非必填（编辑器不显示 *，打印前不校验）
 * 三方任务只产生于交接流程（后端创建时固定 routeType=HANDOVER），但其 routeId=-1，
 * 列表接口的 routeType 由路线表解析、对三方任务返回 null，故此处只判 taskType
 */
export const isHandoverThirdPartyBol = (bolData: { taskType?: number }): boolean =>
    bolData.taskType === TmsTaskTypeEnum.ThirdParty;

/**
 * 封签段的始发站（已取末段缩写，可直接展示），打印页与编辑器共用。
 * 三方任务取「上一段的目的站」而不是本段的 shipFrom：TT 装载计划段间可能不衔接（上一段到 LAX88、本段从 LAX8 发），
 * 按上一段目的站才与 Route 行、站点列、签名区同一条站点链（LAX88 — LAX9），衔接时两者相同（2026-10-20 用户要求）。
 * 其它任务类型仍取本段 shipFrom。
 * @param stops
 * @param taskType
 * @param stopIndex 该段在 stops 中的下标（>= 1，stops[0] 为第一段始发站）
 */
export const sealFromSortCode = (
    stops: { shipFromSortCode?: string; shipToSortCode?: string }[],
    taskType: number | undefined,
    stopIndex: number,
): string => {
    const stop = stops[stopIndex];
    if (taskType !== TmsTaskTypeEnum.ThirdParty) return getAbbrSortCode(stop?.shipFromSortCode);
    return getAbbrSortCode(stops[stopIndex - 1]?.shipToSortCode || stop?.shipFromSortCode);
};

/** 千克转磅（BOL 单据重量以 LB 展示，bag.weight_kg 落库为 kg） */
export const kgToLb = (kg: number): number => kg * 2.20462;
